const validate = values => {
    const errors = {}
    if (!values.firstname) {
      errors.firstname = 'Required'
    }
    if (!values.positionHeld) {
        errors.positionHeld = 'Required'
      }
    if (!values.lastname) {
      errors.lastname = 'Required'
    }
    if (!values.email) {
      errors.email = 'Required'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,21}$/i.test(values.email)) {
      errors.email = 'Invalid email address'
    }
    if (!values.programCode || !/.{4}/.test(values.programCode)) {
        errors.programCode = 'Invalid Program Code address. At least 4 characters'
    }
    // Harmonize password validation with login policy:
    // Minimum 8 chars, at least one letter, one number, and one of (!#$%&*)
    const passwordValue = values.Password || values.password;
    const confirmValue = values.ConfirmPassword || values.confirmPassword;
    if (passwordValue && !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[!#$%&*])[A-Za-z\d!#$%&*]{8,}$/.test(passwordValue)) {
      errors.password = 'Invalid password. Minimum eight characters, at least one letter, one number and one special character (!#$%&*)';
    }
    if (!confirmValue || confirmValue !== passwordValue) {
      errors.ConfirmPassword = 'Password mismatch.';
    }
    if (!values.conIdentificationTypeID) {
        errors.conIdentificationTypeID = 'Required'
    }
    if (!values.identityNo) {
        errors.identityNo = 'Required'
    }
    if (!values.identitytype) {
        errors.identitytype = 'Required'
    }

    if (!values.conTitleID) {
        errors.conTitleID = 'Required'
    }
    if (!values.birthdate) {
        errors.birthdate = 'Required'
    }
    if (!values.language) {
        errors.language = 'Required'
    }
    if (!values.race) {
        errors.race = 'Required'
    }
    if (!values.gender) {
        errors.gender = 'Required'
    }
    if (!values.maritalStatus) {
        errors.maritalStatus = 'Required'
    }
    if (!values.residenceStatus) {
        errors.residenceStatus = 'Required'
    }
    if (!values.address) {
        errors.address = 'Required'
    }
    if (!values.city) {
        errors.city = 'Required'
    }
    if (!values.nationality) {
        errors.nationality = 'Required'
    }
    if (!values.saAreaCode) {
      
        errors.saAreaCode = 'Required'
    }
    if (!values.urbanRural) {
        errors.urbanRural = 'Required'
    }
    if (!values.conSocioEconomicStatus) {
        errors.conSocioEconomicStatus = 'Required'
    }

    if (!values.rating) {
        errors.rating = 'Required'
    }
    if (!values.code) {
        errors.code = 'Required'
    }
    if (!values.code2) {
        errors.code2 = 'Required'
    }
    if (!values.telephone) {
        errors.telephone = 'Required'
    }
    if (!values.cell) {
      
        errors.cell = 'Required'
    }
    if (!values.conRegion) {
        errors.conRegion = 'Required'
    }
    if (!values.lastSchoolEmis) {
        errors.lastSchoolEmis = 'Required'
    }
    if (!values.nationality) {
        errors.nationality = 'Required'
    }
    if (!values.lastSchoolYear) {
        errors.lastSchoolYear = 'Required'
    }
    if (!values.conBranch) {
        errors.conBranch = 'Required'
    }
    if (!values.conCountryID) {
        errors.conCountryID = 'Required'
    }
    if (!values.Terms) {
        errors.Terms = 'Required'
    }
    if (!values.conProvinceID) {
        errors.conProvinceID = 'Required'
    }
    if (!values.conMunicipalAreaID) {
        errors.conMunicipalAreaID = 'Required'
    }
    if (!values.socc) {
        errors.socc = 'Required'
    }
    if (!values.disability) {
        errors.disability = 'Required'
    }
    if (!values.highestQualification) {
        errors.highestQualification = 'Required'
    }
    if (!values.highestSchoolLevel) {
        errors.highestSchoolLevel = 'Required'
    }
    if (!values.driversLicence) {
        errors.driversLicence = 'Required'
    }
    return errors
}
  
  export default validate